<template>
  <div style="display: flex; flex-direction: column;height: 100%">
    <div class="sub-title"><i class="el-icon-user"></i> 用户列表</div>
    <div class="main-shadow-box">
      <el-row style="margin-bottom: 10px;">
        <el-button @click="addVisible = true"
                   style="float: right" type="primary">新增</el-button>
      </el-row>
      <el-table :data="list" size="medium">
        <el-table-column prop="username" label="用户名"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="createTime" label="创建时间">
          <template v-slot="s">{{s.row.createTime | date}}</template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template v-slot="s">
            <el-button @click="openUpdate(s.row.id)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <add-dialog :visible.sync="addVisible"></add-dialog>
    <update-dialog :visible.sync="updateVisible" :user-id="currentUserId"></update-dialog>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import updateDialog from './update'
import addDialog from './add'

export default {
  components: {
    addDialog,
    updateDialog
  },
  data() {
    return {
      addVisible: false,
      updateVisible: false,
      currentUserId: null
    };
  },
  async beforeRouteEnter(to, from, next) {
    if(Vue.store.state.me === null) {
      next(vm => {
        vm.$router.push('login')
      })
    } else {
      await Vue.store.dispatch("user/list");
      next();
    }
  },
  computed: {
    ...mapState("user", ["list"])
  },
  methods: {
    openUpdate(id){
      this.currentUserId = id;
      this.updateVisible = true;
    }
  }
};
</script>
